module.exports = __webpack_public_path__ + "img/quote-end.dc65140a.svg";